/* تعريب صفحة /update-profile الخاصة بـ Web Form "edit-profile".
 * يعمل كنسخة احتياطية لو لغة المستخدم/الموقع ليست العربية، ويعرّب التسميات
 * والأزرار والعناوين ديناميكياً بعد ما الـ Web Form يبني نفسه على المتصفح.
 */
(function () {
	function onProfilePage() {
		var p = (window.location.pathname || "").replace(/\/+$/, "");
		return /^\/update-profile(\/|$)/.test(p);
	}

	if (!onProfilePage()) return;

	var TRANSLATIONS = {
		"Update Profile": "تعديل الحساب",
		"Edit Profile": "تعديل الحساب",
		"My Account": "حسابي",
		"First Name": "الاسم الأول",
		"Middle Name": "الاسم الأوسط",
		"Middle Name (Optional)": "الاسم الأوسط (اختياري)",
		"Last Name": "اسم العائلة",
		"Profile Picture": "صورة الملف الشخصي",
		"More Information": "معلومات إضافية",
		"Phone": "الهاتف",
		"Mobile Number": "رقم الموبايل",
		"Language": "اللغة",
		"Time Zone": "المنطقة الزمنية",
		"Save": "حفظ",
		"Saving...": "جارٍ الحفظ...",
		"Saving": "جارٍ الحفظ",
		"Submit": "حفظ",
		"Submitted": "تم الحفظ",
		"Discard": "إلغاء",
		"Edit": "تعديل",
		"Delete": "حذف",
		"Not Saved": "لم يتم الحفظ",
		"Profile updated successfully.": "تم تحديث البيانات بنجاح.",
		"Profile updated successfully": "تم تحديث البيانات بنجاح",
		"Attachments": "المرفقات",
		"Comments": "التعليقات",
		"Click here": "اضغط هنا",
		"See previous responses": "عرض الإجابات السابقة",
		"Submit another response": "إرسال إجابة أخرى",
		"Mandatory fields required": "حقول إلزامية مطلوبة",
		"This field is mandatory": "هذا الحقل إلزامي",
		"Attach": "إرفاق",
		"Attach File": "إرفاق ملف",
		"Clear": "مسح",
		"Choose a file": "اختر ملفاً",
		"Drag and drop files here or upload": "اسحب وأفلت الملفات هنا أو ارفعها",
		"Web Link": "رابط",
		"Library": "المكتبة",
		"My Device": "جهازي",
		"Set as Cover Image": "تعيين كصورة غلاف",
		"Optimize": "تحسين",
		"Private": "خاص",
		"Upload": "رفع",
		"Successfully Saved": "تم الحفظ بنجاح",
	};

	function translateText(text) {
		if (!text) return text;
		var trimmed = text.replace(/\s+/g, " ").trim();
		if (TRANSLATIONS[trimmed]) return TRANSLATIONS[trimmed];

		var withoutColon = trimmed.replace(/[:：]\s*$/, "").trim();
		if (TRANSLATIONS[withoutColon]) {
			return TRANSLATIONS[withoutColon] + (trimmed.endsWith(":") ? ":" : "");
		}
		return null;
	}

	function translateAttr(el, attr) {
		var v = el.getAttribute(attr);
		if (!v) return;
		var t = translateText(v);
		if (t && t !== v) el.setAttribute(attr, t);
	}

	function translateNode(root) {
		if (!root) return;

		// نصوص العناصر النصية (Labels / Buttons / Headings / Tabs / Sidebar / Indicators)
		var selectors = [
			"label",
			"button",
			".btn",
			".control-label",
			".grid-heading-row .col",
			"h1, h2, h3, h4, h5, h6",
			".section-head, .form-section-heading",
			".indicator-pill",
			".web-form-title, .web-form-introduction",
			".sign-up-message",
			"a",
			"span",
			"p",
			"li",
			"th",
			"td",
		];

		var nodes = root.querySelectorAll
			? root.querySelectorAll(selectors.join(","))
			: [];

		nodes.forEach(function (el) {
			// تجاهل العناصر اللي فيها عناصر فرعية كتيرة (عشان منكسرش HTML)
			if (el.children && el.children.length > 0) return;
			var txt = el.textContent;
			var t = translateText(txt);
			if (t && t !== txt) {
				el.textContent = t;
			}
		});

		// placeholders
		var inputs = root.querySelectorAll
			? root.querySelectorAll("input[placeholder], textarea[placeholder]")
			: [];
		inputs.forEach(function (el) {
			translateAttr(el, "placeholder");
		});

		// عنوان الصفحة
		try {
			var titleTxt = document.title;
			var t = translateText(titleTxt);
			if (t && t !== titleTxt) document.title = t;
		} catch (e) {
			/* تجاهل */
		}
	}

	function applyRtl() {
		document.querySelectorAll(".web-form-container, .web-form").forEach(function (el) {
			el.setAttribute("dir", "rtl");
			el.style.textAlign = "right";
		});
	}

	/* الحقول المسموح ظهورها على صفحة /update-profile */
	var ALLOWED_FIELDS = ["first_name", "user_image"];

	function hideUnwantedFields() {
		/*
		 * نخفي field controls فقط. Frappe بيحط data-fieldname على .form-section
		 * و .form-column كمان، فلازم نحدد .frappe-control عشان منخفيش الـ container
		 * اللي جواه الحقول المسموح بيها.
		 */
		document.querySelectorAll(".frappe-control[data-fieldname]").forEach(function (el) {
			var fn = el.getAttribute("data-fieldname");
			if (!fn) return;
			if (ALLOWED_FIELDS.indexOf(fn) !== -1) return;
			el.style.display = "none";
		});

		/* إخفاء أزرار الحذف */
		document.querySelectorAll(".delete-btn").forEach(function (btn) {
			btn.style.display = "none";
		});

		/* إخفاء أي section مفيهاش حقول مسموح بها (مثل More Information) */
		document.querySelectorAll(".web-form .form-section").forEach(function (sec) {
			var allowedInside = sec.querySelector(
				".frappe-control[data-fieldname='first_name'], .frappe-control[data-fieldname='user_image']"
			);
			if (!allowedInside) {
				sec.style.display = "none";
			}
		});

		/* إخفاء الأعمدة الفاضية بعد ما الحقول اللي جواها اتخفت */
		document.querySelectorAll(".web-form .form-column").forEach(function (col) {
			var allowedInside = col.querySelector(
				".frappe-control[data-fieldname='first_name'], .frappe-control[data-fieldname='user_image']"
			);
			if (!allowedInside) {
				col.style.display = "none";
			}
		});
	}

	var DEFAULT_AVATAR = "/files/avatar_for_all.png";

	function customizeProfilePicField() {
		var ctrl = document.querySelector('.frappe-control[data-fieldname="user_image"]');
		if (!ctrl) return;

		var attachedFile = ctrl.querySelector(".attached-file");
		var link = attachedFile ? attachedFile.querySelector(".attached-file-link") : null;
		var src = link ? link.getAttribute("href") : null;

		var container =
			ctrl.querySelector(".control-input-wrapper") ||
			ctrl.querySelector(".control-input") ||
			ctrl;

		var img = ctrl.querySelector(".mygabal-profile-pic-preview");
		if (!img) {
			img = document.createElement("img");
			img.className = "mygabal-profile-pic-preview";
			img.alt = "صورة الملف الشخصي";
			container.insertBefore(img, container.firstChild);
		}
		var newSrc = src || DEFAULT_AVATAR;
		if (img.getAttribute("src") !== newSrc) {
			img.setAttribute("src", newSrc);
		}

		var editBtn = ctrl.querySelector(".mygabal-profile-pic-edit");
		if (!editBtn) {
			editBtn = document.createElement("button");
			editBtn.type = "button";
			editBtn.className = "mygabal-profile-pic-edit";
			editBtn.textContent = "تعديل الصورة";
			editBtn.addEventListener("click", function (e) {
				e.preventDefault();
				var attachBtn = ctrl.querySelector(".btn-attach");
				if (attachBtn) {
					attachBtn.click();
				} else if (attachedFile) {
					var reload = attachedFile.querySelector('[data-action="reload_attachment"]');
					if (reload) reload.click();
				}
			});
			container.appendChild(editBtn);
		}
	}

	/* Monkey-patch لـ ControlAttach عشان يخلي الرفع كله public ومايسألش */
	function patchAttachToPublic() {
		if (
			!window.frappe ||
			!frappe.ui ||
			!frappe.ui.form ||
			!frappe.ui.form.ControlAttach ||
			!frappe.ui.form.ControlAttach.prototype
		)
			return;

		if (frappe.ui.form.ControlAttach.__mygabal_public_patched) return;

		var proto = frappe.ui.form.ControlAttach.prototype;
		var orig = proto.set_upload_options;
		proto.set_upload_options = function () {
			orig.apply(this, arguments);
			if (!this.upload_options) return;
			this.upload_options.make_attachments_public = 1;
			this.upload_options.allow_toggle_private = false;
			this.upload_options.options = this.upload_options.options || {};
		};
		frappe.ui.form.ControlAttach.__mygabal_public_patched = true;
	}

	function runOnce() {
		applyRtl();
		translateNode(document);
		hideUnwantedFields();
		customizeProfilePicField();
		patchAttachToPublic();
	}

	function start() {
		patchAttachToPublic();
		runOnce();

		var observer = new MutationObserver(function (mutations) {
			var needsRun = false;
			for (var i = 0; i < mutations.length; i++) {
				if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
					needsRun = true;
					break;
				}
				if (mutations[i].type === "characterData") {
					needsRun = true;
					break;
				}
			}
			if (needsRun) {
				clearTimeout(window.__mygabal_profile_t);
				window.__mygabal_profile_t = setTimeout(runOnce, 60);
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
			characterData: true,
		});

		// إعادة المحاولة كل نص ثانية لمدة 5 ثواني (لو الـ web form لسه بيتركّب)
		var attempts = 0;
		var iv = setInterval(function () {
			runOnce();
			attempts += 1;
			if (attempts >= 10) clearInterval(iv);
		}, 500);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start);
	} else {
		start();
	}
})();
